import http from '@/api/common'

export default {
  getDevice(serialNumber) {
    return http.get(`device/GetDevice?serialNumber=${serialNumber}`)
  },
  getDeviceById(id) {
    return http.get(`device/GetDeviceById?id=${id}`)
  },
  getDevices(searchOptions) {
    return http.get('device/GetDevicesForListing', {
      params: searchOptions
    })
  },
  downloadAllTools(id) {
    return http.get(`device/GetAllTools?id=${id}`)
  },
  getTools(searchOptions) {
    return http.get('device/GetToolsForListing', {
      params: searchOptions
    })
  },
  getdevicefiles(searchOptions) {
    return http.get('device/GetAllDeviceFiles', {
      params: searchOptions
    })
  },
  getDeviceFileById(id) {
    return http.get(`device/GetDeviceFileById?id=${id}`)
  },
  getToolMakes(id) {
    return http.get(`device/GetToolMakes?id=${id}`)
  },
  createDevice(data) {
    return http.post('device/CreateDevice', data)
  },
  activateDevice(data) {
    return http.post('smartlink/activateDevice', data)
  },
  getDeviceActivation(data) {
    return http.post('smartlink/DeviceActivatationInfo', data)
  },
  updateDevice(data) {
    return http.post('device/UpdateDevice', data)
  },
  updateDeviceFile(data) {
    return http.post('device/UpdateDeviceFile', data)
  },
  upsertDeviceShipment(data) {
    return http.post('device/UpsertDeviceShipment', data)
  },
  addToolMake(data) {
    return http.post('device/AddToolMake', data)
  },
  deleteToolMake(id) {
    return http.get(`device/DeleteToolMake?id=${id}`)
  },
  assignDevice(data) {
    return http.post('device/AssignDevice', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/device.js